import {Component, OnInit, Input, OnChanges, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-tab-header',
  templateUrl: './tab-header.component.html',
  styleUrls: ['./tab-header.component.scss']
})

export class TabHeaderComponent implements OnChanges {
  @Input() title = '';
  @Input() tabs;
  @Input() activeTab = 'tab1';
  @Output() tabChange = new EventEmitter<string>();

  constructor() {
  }

  changeTab(tab) {
    this.tabChange.emit(tab);
  }

  ngOnChanges(changes) {
    if (changes.tabs && changes.tabs.currentValue.length) {

    }
  }
}
